import { FormattedMessage } from 'react-intl';
import React, { useState } from 'react';
import QRCode from 'qrcode.react';

import { defaultLinks } from '../../../utils/downloadLinks';

import LinkCurrentDeviceButton from '../DeviceManagment/LinkCurrentDeviceButton';

import { isMobile } from '../../../utils/platformResolver';
import styles from './DesktopInstallCol.scss';

const constructMobileQR = (downloadToken) => {
  const mobileURL = new URL(defaultLinks.android);

  mobileURL.searchParams.append('deep_link_sub1', downloadToken);
  mobileURL.searchParams.append('permanent_token', downloadToken);

  return mobileURL.toString();
};

const MobilePairCol = ({ downloadToken, refreshDownloadToken }) => {
  const [isMobileVersion] = useState(isMobile());

  const qrLink = constructMobileQR(downloadToken);

  return (
    <section className={styles.desktop}>
      <h3>
        <FormattedMessage
          id="profile.downloadModal.mobileSlide.pair.title"
          defaultMessage="2. Connect your account"
          description="Title of the pair column instructions for mobile slide of Download Modal"
        />
      </h3>
      <span>
        {isMobileVersion ? (
          <FormattedMessage
            id="profile.downloadModal.mobileSlide.pair.subtitleWithButton"
            defaultMessage="Connect your mobile device by tapping the button below"
            description="Subtitle of the pair column instructions for mobile slide of Download Modal, urges to click the button"
          />
        ) : (
          <FormattedMessage
            id="profile.downloadModal.mobileSlide.pair.subtitleWithQr"
            defaultMessage="Connect your mobile device by scanning QR code below"
            description="Subtitle of the pair column instructions for mobile slide of Download Modal, urges to scan a QR"
          />
        )}
      </span>

      {isMobileVersion ? (
        <LinkCurrentDeviceButton
          downloadToken={downloadToken}
          refreshDownloadToken={refreshDownloadToken}
          className={styles.mobilePairButton}
        >
          <FormattedMessage
            id="profile.downloadModal.desktopSlide.pair.pairButton"
            defaultMessage="Pair device"
            description="Button of the section for pairing device with the account, opens app via deeplink to authenticate user with the same account"
          />
        </LinkCurrentDeviceButton>
      ) : (
        <QRCode value={qrLink} size={120} bgColor="#fff" includeMargin />
      )}
    </section>
  );
};

export default MobilePairCol;
